import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Select from "react-dropdown-select";
//import { useSelector } from "react-redux";

export const UIMeses = ({ periodoProgramado, handleInputChange }) => {
  //const { actaActiva } = useSelector((state) => state.planificacion);
  const anio = '2023';

  const handleSelectChange = ( valor ) => {
      const e = { target: { 'name': 'periodoProgramado', 'value': valor[0].mes }};
  
      handleInputChange( e );
  }
  const meses = [ { id: 1, mes : `Enero/${anio}` }, 
                  { id: 2, mes : `Febrero/${anio}` },
                  { id: 3, mes : `Marzo/${anio}` },
                  { id: 4, mes : `Abril/${anio}` },
                  { id: 5, mes : `Mayo/${anio}` }, 
                  { id: 6, mes : `Junio/${anio}` },
                  { id: 7, mes : `Julio/${anio}` }, 
                  { id: 8, mes : `Agosto/${anio}` },
                  { id: 9, mes : `Septiembre/${anio}` }, 
                  { id: 10, mes : `Octubre/${anio}` },
                  { id: 11, mes : `Noviembre/${anio}` }, 
                  { id: 12, mes : `Diciembre/${anio}` }];
  
  let mesActual = [{ id: (new Date()).getMonth() + 1, mes: meses[(new Date()).getMonth()].mes }];

  if (periodoProgramado.length > 0) {
    const mes = meses.filter(item => item.mes === periodoProgramado ) 
    mesActual = mes;  
  }
  
  useEffect(() => {
    handleSelectChange( mesActual );
  }, [])

  return (
    <Grid item xs={12} >
      <Grid item xs={12} >
        Periodo
      </Grid>
        <Grid container>
          <Grid item xs={12} >
            <Select options={ meses } 
              values={ mesActual }
              valueField='id'
              labelField='mes'
              searchBy='mes'
              onChange={ ( e ) => handleSelectChange( e )} />
          </Grid>
        </Grid>
    </Grid>
  );
};